module.exports = {
          srcSet: __webpack_public_path__ + "1444120a.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "1444120a.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "1444120a.jpg",
          toString:function(){return __webpack_public_path__ + "1444120a.jpg"},
          
          width: 330,
          height: 200
        }